import React from "react";
import Icon from "../../../../common/components/Icon";

const GREY_FILTER  = '[filter:brightness(0)_saturate(100%)_invert(55%)_sepia(0%)_saturate(0%)_brightness(90%)]';
const GREEN_FILTER = '[filter:brightness(0)_saturate(100%)_invert(18%)_sepia(70%)_saturate(6415%)_hue-rotate(142deg)_brightness(93%)_contrast(84%)]';

function UserModalItem({ iconPath, itemName, danger }) {
    return (
        <div className={`flex items-center justify-between px-3 py-2.5 rounded-xl transition-colors cursor-pointer ${danger ? 'hover:bg-red-50 group/danger' : 'hover:bg-[#F5F5F5]'}`}>
            <div className="flex items-center gap-3">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${danger ? 'bg-red-50' : 'bg-[#F5F5F5]'}`}>
                    <Icon
                        src={iconPath}
                        alt={itemName}
                        className={`w-4 h-4 ${danger ? '[filter:brightness(0)_saturate(100%)_invert(27%)_sepia(80%)_saturate(1200%)_hue-rotate(330deg)_brightness(90%)]' : GREY_FILTER}`}
                    />
                </div>
                <span className={`text-[13px] font-medium ${danger ? 'text-red-500' : 'text-[#333]'}`}>
                    {String(itemName)}
                </span>
            </div>
            {!danger && (
                <Icon src="right_arrow" alt="" className={`w-4 h-4 ${GREY_FILTER}`} />
            )}
        </div>
    );
}

export default UserModalItem;
